<template>
  <div class="result-line" :class="textColor">
    <div class="arrow-box d-flex justify-center align-center" :class="arrowBoxClass">
      <mf-icon size="20" color="white">{{ icon }}</mf-icon>
    </div>
    <span>{{ text }}</span>
    <span :class="blurClass">{{ value }}</span>
  </div>
</template>

<script>
export default {
  props: {
    isNegative: {
      type: Boolean,
      default: false,
    },
    isBlur: {
      type: Boolean,
      default: false,
    },
    text: {
      type: String,
      required: true,
    },
    value: {
      type: String,
      required: true,
    },
  },
  computed: {
    arrowBoxClass() {
      return this.isNegative ? 'arrow-box_down' : 'arrow-box_up'
    },
    icon() {
      return this.isNegative ? 'arrow_downward' : 'arrow_upward'
    },
    blurClass() {
      return this.isBlur ? 'blur-text' : ''
    },
    textColor() {
      return this.isNegative ? 'negative-text' : 'positive-text'
    },
  },
}
</script>

<style scoped lang="scss">
.result-line {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: 6px;
}

.arrow-box {
  height: 20px;
  width: 20px;
  border-radius: 4px;
  margin: 0;
  padding: 10px;

  &_up {
    background-color: $verde-0;
  }
  &_down {
    background-color: $vermelho-0;
  }
}

.blur-text {
  filter: blur(3px);
  user-select: none;
}

.negative-text {
  color: $vermelho-0;
}

.positive-text {
  color: $verde-0;
}
</style>
